import React, { ReactNode, useRef } from 'react';
import ClickAnimation from '@/components/base/ClickAnimationWrapper';
import Modal from '@/components/base/Modal';
import BridgeModal from '@/components/modules/BridgeModal';
import BridgeModalSponsor from '@/components/modules/BridgeModalSponsor';
import { getBrigeLinkTemplateImage } from '@/managers/BridgePages';
import styles from './BridgeLink.module.scss';

interface Props {
  clickAnimation?: boolean,
  href: string,
  title: string,
  modalImage?: string,
  imageAltText?: string
  modalHeader?: string,
  modalBody?: string,
  linkLogo?: string,
  children: ReactNode,
  className?: string,
}

const BridgeLink: React.FC<Props> = ({
  clickAnimation = false,
  href,
  title,
  modalImage,
  imageAltText,
  modalHeader,
  modalBody,
  linkLogo,
  children,
  className,
}) => {
  const ref = useRef<HTMLButtonElement|null>(null);
  const buttonClass = `${styles.button} ${className || ''}`;
  const modalClass = modalImage ? styles.modalOverride : styles.closeButtonOverride;

  const ModalType = () => {
    if (modalImage) {
      return (
        <BridgeModalSponsor
          link={ href }
          title={ title }
          image={ modalImage }
          imageAltText={ imageAltText || title || ''}
          header={ modalHeader }
          body={ modalBody }
        />
      );
    } else {
      return (
        <BridgeModal
          link={ href }
          title={ title }
          image={ getBrigeLinkTemplateImage(href) || linkLogo }
        />
      );
    }
  };

  return <>
    <Modal
      modalOverrideClass={modalClass}
      portalDestinationSelector={'[data-root-wrapper]'}
      toggleButtonRef={ ref }
    >
      <ModalType/>
    </Modal>

    { clickAnimation ?
      <ClickAnimation>
        <button ref={ ref } className={buttonClass}>
          { children }
        </button>
      </ClickAnimation> :
      <button ref={ ref } className={buttonClass}>
        { children }
      </button>
    }
  </>;
};

export default BridgeLink;
